<aslib-title Text="Controle de Projetos" SubText=" " Icon="fa fas fa-tasks"></aslib-title>

<!-- <aslib-modal #modal></aslib-modal> -->

<div class="form-row">
  <div class="form-group col-sm-5">
    <button type="button" class="btn btn-primary" (click)="openModalProjetos(modalProjeto)">Incluir Projeto</button>
    <ng-template #modalProjeto>
      <gpa-modal-projeto></gpa-modal-projeto>
    </ng-template>
  </div>
</div>


<aslib-grid #grid id="grid" name="grid" headerTitle="Projetos" [(dataset)]="lista" indexColumnVisible="true" limit="10">
  <aslib-grid-column [property]="'CodProjeto'" header="Sigla" class="text-left" [width]="10"    [sortable]="true" [resizable]="true"></aslib-grid-column>
  <aslib-grid-column [property]="'DescricaoProjeto'" header="Descrição" class="text-left" [width]="15" [sortable]="true"   [resizable]="true"></aslib-grid-column>
  <aslib-grid-column [property]="'active'" [header]="'Ações'" [width]="2" [sortable]="false" [resizable]="false" class="text-center">
    <ng-template #AslibGridHeader let-item="item"><span>Ações</span></ng-template>
    <ng-template #AslibGridCell let-item="item">
    <button type="button" class="btn btn-sm btn-danger" title="Excluir Projeto" ascas-data="Excluir Projeto" (click)="excluirProjeto(modal,item)">
      <aslib-icon type="1" icon="fa fa-fw fa-trash"></aslib-icon>
    </button>
    </ng-template>
  </aslib-grid-column>
</aslib-grid>
<br>



// WEBPACK FOOTER //
// ./src/app/controle-dados/projeto/projeto.component.html